// Mock authentication provider for local development
// This bypasses Azure AD authentication to allow UI development without deployment

import { AccountInfo } from '@azure/msal-browser';
import { PartnerProfile, PartnerAuthContext, Customer } from '../types/partner';

// Mock account for dev mode
export const mockAccount: AccountInfo = {
  homeAccountId: 'mock-home-account-id',
  environment: 'login.microsoftonline.com',
  tenantId: 'mock-tenant-id',
  username: 'dev.user@aitryx.local',
  localAccountId: 'mock-local-account-id',
  name: 'Dev User',
  idTokenClaims: {
    name: 'Dev User',
    email: 'dev.user@aitryx.local',
    sub: 'mock-user-id',
  },
};

// Mock partner profile for dev mode
export const mockPartnerProfile: PartnerProfile = {
  partnerId: 'mock-partner-1',
  partnerName: 'Mock Partner Organization',
  adminFirstName: 'Dev',
  adminLastName: 'User',
  adminEmail: 'dev.user@aitryx.local',
  adminContactNumber: '+61 400 000 000',
  country: 'Australia',
  status: 'Active',
  createdAt: new Date().toISOString(),
  website: 'https://mock-partner.example.com',
  partnerEmail: 'info@mock-partner.example.com',
  partnerContactNumber: '+61 400 000 001',
  managedCustomerCount: 3,
  isAlsoCustomer: false,
  permissions: {
    canManageCustomers: true,
    canViewReports: true,
    canExportData: true,
    canAccessCustomerApp: false,
  },
};

// Mock customers for dev mode
export const mockCustomers: Customer[] = [
  {
    customerId: 'mock-customer-1',
    customerName: 'Acme Corporation',
    adminFirstName: 'John',
    adminLastName: 'Doe',
    adminEmail: 'john.doe@acme.example.com',
    contactNumber: '+61 400 000 100',
    country: 'Australia',
    industry: 'Technology',
    msTenantId: 'mock-ms-tenant-1',
    partnerId: 'mock-partner-1',
    subscriptionTier: 'Enterprise',
    licenseCount: 50,
    createdAt: new Date().toISOString(),
    status: 'Active',
    domain: 'acme.example.com',
  },
  {
    customerId: 'mock-customer-2',
    customerName: 'TechStart Inc',
    adminFirstName: 'Jane',
    adminLastName: 'Smith',
    adminEmail: 'jane.smith@techstart.example.com',
    contactNumber: '+61 400 000 200',
    country: 'Australia',
    industry: 'Startup',
    msTenantId: 'mock-ms-tenant-2',
    partnerId: 'mock-partner-1',
    subscriptionTier: 'Professional',
    licenseCount: 25,
    createdAt: new Date().toISOString(),
    status: 'Active',
    domain: 'techstart.example.com',
  },
  {
    customerId: 'mock-customer-3',
    customerName: 'Global Solutions Ltd',
    adminFirstName: 'Bob',
    adminLastName: 'Johnson',
    adminEmail: 'bob.johnson@global.example.com',
    contactNumber: '+61 400 000 300',
    country: 'Australia',
    industry: 'Consulting',
    msTenantId: 'mock-ms-tenant-3',
    partnerId: 'mock-partner-1',
    subscriptionTier: 'Enterprise',
    licenseCount: 100,
    createdAt: new Date().toISOString(),
    status: 'Active',
    domain: 'global.example.com',
  },
];

// Mock partner auth context for dev mode
export const mockPartnerAuthContext: PartnerAuthContext = {
  isPartner: true,
  partnerId: 'mock-partner-1',
  partnerUserId: 'mock-partner-user-id',
  isPartnerAdmin: true,
  partnerInfo: {
    partnerId: 'mock-partner-1',
    partnerName: 'Mock Partner Organization',
    adminFirstName: 'Dev',
    adminLastName: 'User',
    adminEmail: 'dev.user@aitryx.local',
    adminContactNumber: '+61 400 000 000',
    country: 'Australia',
    status: 'Active',
    createdAt: new Date().toISOString(),
    website: 'https://mock-partner.example.com',
    partnerEmail: 'info@mock-partner.example.com',
    partnerContactNumber: '+61 400 000 001',
  },
  currentUser: {
    partnerUserId: 'mock-partner-user-id',
    email: 'dev.user@aitryx.local',
    firstName: 'Dev',
    lastName: 'User',
    isAdmin: true,
    status: 'Active',
    lastLoginAt: new Date().toISOString(),
  },
  managedCustomers: mockCustomers,
  managedCustomerCount: mockCustomers.length,
  assignedCustomers: mockCustomers,
  assignedCustomerCount: mockCustomers.length,
  isAlsoCustomer: false,
  canAccessCustomerView: false,
  permissions: {
    canManageCustomers: true,
    canViewReports: true,
    canExportData: true,
    canAccessCustomerApp: false,
    canManageStaff: true,
  },
};

// Mock token for dev mode (not a real token, just a placeholder)
export const mockAccessToken = 'mock-dev-token-not-for-production-use';

